<template>
   <div>
      <button :id="modalBtnId" :data-bs-target="`#${modalId}`" data-bs-toggle="modal" style="display: none" />
      <div
         :id="modalId"
         :aria-labelledby="modalId"
         aria-hidden="true"
         class="modal fade modal-custom"
         data-bs-backdrop="static"
         data-bs-keyboard="false"
         role="dialog"
         tabindex="-1"
      >
         <div class="modal-dialog" role="document">
            <div class="modal-custom__content">
               <ValidationObserver ref="observer" v-slot="{ passes, reset }">
                  <div class="modal-custom__header">
                     <span class="modal-custom__action" data-bs-dismiss="modal" @click.prevent="reset">
                        <i class="icon-fonts icon-fonts--close"></i>
                     </span>
                  </div>
                  <div class="modal-custom__body">
                     <h3 class="modal-custom__title">
                        {{ title ?? $t('ftth.change_product.registration_confirmation') }}
                     </h3>
                     <p class="modal-custom__des">{{ des ?? $t('ftth.change_product.titlePopup') }}</p>
                     <form @submit.prevent="passes(submitOTP)" @reset.prevent="hideModalOTP">
                        <div class="modal-custom__form">
                           <ValidationProvider
                              v-slot="{ errors }"
                              :name="$t('ftth.change_product.OTP')"
                              class="form-customize"
                              mode="passive"
                              rules="required|equal:6"
                              tag="div"
                           >
                              <div class="form-input">
                                 <input
                                    v-model="OTP_POPUP"
                                    :placeholder="$t('ftth.change_product.OTP_placeholder')"
                                    class="form-control"
                                    maxlength="6"
                                    onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
                                    pattern="[0-9]*"
                                    type="text"
                                 />
                                 <p v-if="errors[0]" class="error-text">{{ errors[0] }}</p>
                                 <span class="input-time">{{ countDownText }}</span>
                              </div>
                           </ValidationProvider>
                           <div class="modal-custom__otp">
                              <span
                                 style="
                                    color: #979797;
                                    font-size: 12px;
                                    line-height: 20px;
                                    text-align: center;
                                    margin-right: 5px;
                                 "
                                 >{{ $t('mobile.data_packages.not_receive_otp') }}</span
                              >
                              <a
                                 :disabled="!isEnd"
                                 class="modal-custom__otp-link fw-bold"
                                 href="javascript:void(0)"
                                 @click="resendOTP"
                              >
                                 {{ $t('mobile.data_packages.resend_otp') }}
                              </a>
                           </div>
                        </div>
                        <div class="modal-custom__btn">
                           <button class="button button--primary button--medium" type="submit">
                              {{ $t('buttons.confirm') }}
                           </button>
                        </div>
                     </form>
                  </div>
               </ValidationObserver>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import $ from 'jquery'
import BaseComponent from '@/mixins/BaseComponent'
import { ValidationObserver } from 'vee-validate'

export default {
   name: 'OtpModal',
   mixins: [BaseComponent],
   components: { ValidationObserver },
   props: {
      isShowOTP: Boolean,
      periodTime: Number,
      modalId: String,
      modalBtnId: String,
      title: {
         type: String,
         required: false
      },
      des: {
         type: String,
         required: false
      }
   },
   beforeDestroy() {
      clearInterval(this.timer)
   },
   data() {
      return {
         OTP_POPUP: '',
         totalTime: this.periodTime || 0,
         timer: null,
         countDownText: '',
         isEnd: false
      }
   },
   methods: {
      async resendOTP() {
         this.setCountDown()
         this.$emit('resendOtp')
         this.OTP_POPUP = ''
      },
      setCountDown() {
         clearInterval(this.timer)
         let timer = this.totalTime
         console.log('timer ' + timer)
         let minutes, seconds
         const vm = this
         this.isEnd = false
         vm.countDownText = '--:--'
         this.timer = setInterval(function () {
            minutes = parseInt(timer / 60, 10)
            seconds = parseInt(timer % 60, 10)

            minutes = minutes < 10 ? '0' + minutes : minutes
            seconds = seconds < 10 ? '0' + seconds : seconds

            vm.countDownText = minutes + ':' + seconds

            if (--timer < 0) {
               clearInterval(vm.timer)
               vm.isEnd = true
            }
         }, 1000)
      },
      resetCountDown() {
         clearInterval(this.timer)
         this.isEnd = false
         let minutes, seconds
         minutes = parseInt(this.totalTime / 60, 10)
         seconds = parseInt(this.totalTime % 60, 10)

         minutes = minutes < 10 ? '0' + minutes : minutes
         seconds = seconds < 10 ? '0' + seconds : seconds

         this.countDownText = minutes + ':' + seconds
         this.totalTime = this.periodTime
      },
      hideModalOTP() {
         clearInterval(this.timer)
         this.resetCountDown()
         this.$refs.observer.reset()
         this.$emit('closeOTP')
         $('#hideModalOTP').trigger('click')
      },
      submitOTP() {
         if (this.OTP_POPUP && this.OTP_POPUP.length == 6) {
            this.$emit('verifyOtp', this.OTP_POPUP)
         }
      }
   },
   watch: {
      isShowOTP(newValue) {
         if (newValue === true) {
            this.totalTime = this.periodTime
            this.setCountDown()
            this.OTP_POPUP = ''
         }
      },
      async OTP_POPUP(val) {
         if (val && val.length == 6) {
            this.$emit('verifyOtp', this.OTP_POPUP)
            this.hideModalOTP()
         }
      }
   }
}
</script>

<style lang="scss" scoped>
.modal-custom {
   &__action {
      color: var(--bs-white);
      background: var(--bs-primary);
      border-radius: 50%;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
         font-size: 18px;
      }
   }
}
</style>
